<template>
  <div>
    <div class="banner">
      <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
    </div>
    <section class="has-background-light" style="padding-bottom: 20px;">
      <br><h1 class="title is-4">ลงทะเบียนประกันภัย</h1>
    </section>
    <section class="hero has-background-light is-fullheight" v-show="!sendQRSuccess">
      <div class="hero-body-custom" >
        <div class="container">
          <div class="columns is-centered">
            <div class="column is-5-tablet is-4-desktop is-3-widescreen">
              <div class="container"><br>
                <div class="field">
                  <label class="label">สาขา <span class="has-text-danger">*</span></label>
                  <div class="select">
                    <select v-model="carInfo.branch">
                      <option v-for="branch in $branchList" v-bind:key="branch.id" :value="branch.id" >{{ branch.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="field">
                  <label class="label">ชื่อลูกค้า <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="ชื่อลูกค้า" v-model="carInfo.customerName">
                  </div>
                </div>
                <div class="field">
                  <label class="label">เบอร์มือถือ <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <masked-input mask="11-1111-1111" class="input" type="text" placeholder="เบอร์มือถือ" v-model="carInfo.customerMobile" />
                  </div>
                </div>
                <div class="field">
                  <label class="label">เลขตัวถัง <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="เลขตัวถัง" v-model="carInfo.frameNo">
                  </div>
                </div>
                <div class="field">
                  <label class="label">เลขทะเบียน <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="เลขทะเบียน" v-model="carInfo.licenseNo">
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-two">
                    <div class="field">
                      <label class="label">รุ่นรถ</label>
                      <div class="select">
                        <select v-model="carInfo.Model">
                          <option v-for="model in models" v-bind:key="model" :value="model" >{{ model }}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label class="label">บริษัทประกันภัย <span class="has-text-danger">*</span></label>
                  <div class="select">
                    <select v-model="carInfo.Insurrance">
                      <option v-for="insurrance in insurrances" v-bind:key="insurrance" :value="insurrance" >{{ insurrance }}</option>
                    </select>
                  </div>
                </div>
                <div class="field" v-show="carInfo.Insurrance == 'other'">
                  <label class="label">บริษัทประกันภัยอื่นๆ <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="บริษัทประกันภัยอื่นๆ" v-model="carInfo.insurranceOther">
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-one-two">
                    <div class="field">
                      <label class="label">วันเริ่มคุ้มครอง <span class="has-text-danger">*</span></label>
                      <div class="control">
                        <masked-input mask="11/11/1111" class="input" type="text" placeholder="วันเริ่มคุ้มครอง" v-model="carInfo.startDate" /><br>
                        <small>eg: 12/05/2020</small>
                      </div>
                    </div>
                  </div>
                  <div class="column is-one-two">
                    <div class="field">
                      <label class="label">วันหมดอายุ <span class="has-text-danger">*</span></label>
                      <div class="control">
                        <masked-input mask="11/11/1111" class="input" type="text" placeholder="วันหมดอายุ" v-model="carInfo.endDate" /><br>
                        <small>eg: 12/05/2020</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="field">
                  <label class="label">เลขที่รับแจ้ง/เลขกรมธรรม์ <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="เลขที่รับแจ้ง/เลขกรมธรรม์" v-model="carInfo.NoticeNo">
                  </div>
                </div>
                <div class="field">
                  <label class="label">ประเภทประกันภัย <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="ประเภทประกันภัย" v-model="carInfo.insuranceType">
                  </div>
                </div>
                <div class="field">
                  <label class="label">ชื่อที่ปรึกษาการขายประกัน <span class="has-text-danger">*</span></label>
                  <div class="control">
                    <input class="input" type="text" placeholder="ชื่อที่ปรึกษาการขายประกัน" v-model="carInfo.consultName">
                  </div>
                </div>
                <br>
                <p v-if="errors.length">
                  <ul>
                    <li v-for="error in errors" v-bind:key="error" class="has-text-danger">{{ error }}</li>
                  </ul><br>
                </p>
                <button class="button is-success" v-on:click="submitCarInfo">{{ btn_action }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <article class="message is-success" v-show="sendQRSuccess">
      <div class="message-header">
        <p>ส่ง QR Code ไปที่ LINE Group Admin Insurrace เรียบร้อยแล้ว</p>
      </div>
      <div class="message-body">
        <button class="button is-link" v-on:click="newCustomer">ลงทะเบียนรถใหม่</button>
      </div>
    </article>
  </div>
</template>
<style>
.hero-body-custom {
  display: flex;
  padding: 0 !important;
}
.banner {
  text-align: center;
  background-color: #000;
}
</style>
<style scoped>
small {
  font-size: 12px;
}
</style>
<script>
import QrcodeVue from 'qrcode.vue'
import MaskedInput from 'vue-masked-input'

export default {
  name: 'RegisterNewCar',
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
  },
  components: {
    QrcodeVue,
    MaskedInput
  },
  data: () => ({
    urlconfirm: `line://app/1653760842-yoeKGZzR?`,
    size: 200,
    registerSuccess: false,
    sendQRSuccess: false,
    errors: [],
    profile: {
      userId: '',
      displayName: '',
      pictureUrl: '',
      statusMessage: ''
    },
    carInfo: {
      branch: '',
      customerName: '',
      customerMobile: '',
      frameNo: '',
      licenseNo: '',
      Model: '',
      Insurrance: '',
      insurranceOther: '',
      startDate: '',
      endDate: '',
      consultName: '',
      NoticeNo: '',
      insuranceType: ''
    },
    carId: '',
    btn_action: 'Submit',
    updatedBy: '',
    models: [
      '', 'Accord', 'Accord. EHEV', 'BR-V', 'CR-V', 'CR-V e HEV', 'WR-V', 'Brio Amaze', 'Brio', 'City', 'CIVIC e:Hev', 'Civic Hatchback', 'Civic', 'HR-V', 'HRV e:HEV', 'Jazz', 'Mobilio', 'FREED', 'STEP WGN', 'ODYSSEY', 'STREAM'
    ],
    insurrances: [
      '',
      'บริษัท กรุงเทพประกันภัย จำกัด (มหาชน)',
      'บริษัท ธนชาตประกันภัย จำกัด (มหาชน)',
      'บริษัท คุ้มภัยโตเกียวมารีนประกันภัย (ประเทศไทย) จำกัด (มหาชน)',
      'บริษัท ซมโปะ ประกันภัย (ประเทศไทย) จำกัด (มหาชน)',
      'บริษัท แอกซ่าประกันภัย จำกัด (มหาชน)',
      'บริษัท มิตซุย สุมิโตโม อินชัวร์รันซ์ จำกัด (สาขาประเทศไทย)',
      'บริษัท แอลเอ็มจี ประกันภัย จำกัด (มหาชน)',
      'บริษัท สินทรัพย์ประกันภัย จำกัด',
      'บริษัท สินมั่งคงประกันภัย จำกัด',
      'บริษัท เอ็ม เอส ไอ จี ประกันภัย จำกัด',
      'บริษัท ทิพยประกันภัย จำกัด (มหาชน)',
      'บริษัท วิริยะประกันภัย จำกัด (มหาชน)',
      'บริษัท ประกันภัยไทยวิวัฒน์ จำกัด (มหาชน)',
      'บริษัท อลิอันซ์ อยุธยา ประกันภัย จำกัด (มหาชน)',
      'บริษัท อาคเนย์ประกันภัย จำกัด (มหาชน)',
      'other'
    ],
    colors: [
      { 'code': 'CBL', 'title': 'Black' },
      { 'code': 'IGR', 'title': 'Red' },
      { 'code': 'LUS', 'title': 'Silver' },
      { 'code': 'MST', 'title': 'Gray' },
      { 'code': 'PAR', 'title': 'Red' },
      { 'code': 'PHO', 'title': 'Orange' },
      { 'code': 'PMW', 'title': 'White' },
      { 'code': 'RLR', 'title': 'Red' },
      { 'code': 'SNG', 'title': 'Silver' },
      { 'code': 'TTW', 'title': 'White' },
      { 'code': 'CBM', 'title': 'Cosmic Blue' },
      { 'code': 'MTS', 'title': 'Meteoroid Gray Metallic' },
      { 'code': 'OSB', 'title': 'Obsidian Blue Pearl' },
      { 'code': 'MTG', 'title': 'Meteoroid Gray Metallic' },
      { 'code': 'BSB', 'title': 'Brilliant Sporty Blue Metallic' },
      { 'code': 'PSW', 'title': 'Premium Sunlight White Pearl' },
      { 'code': 'IRB', 'title': 'IRB' },
      { 'code': 'STD', 'title': 'STD' },
      { 'code': 'CYB', 'title': 'CYB' },
      { 'code': 'SKC', 'title': 'KHAKI SAND' }
    ]
  }),
  mounted () {
    if (!this.$session.exists() || (typeof this.$session.get('vgroup') === 'undefined' || this.$session.get('vgroup') === '')) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
    let _this = this
    _this.updatedBy = this.$session.get('vgroup')
    this.getToday()
  },
  methods: {
    getToday () {
      const date = new Date()
      this.carInfo.expectedDate = ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear()
    },
    newCustomer () {
      this.carInfo.branch = ''
      this.carInfo.customerName = ''
      this.carInfo.customerMobile = ''
      this.carInfo.frameNo = ''
      this.carInfo.licenseNo = ''
      this.carInfo.Model = ''
      this.carInfo.Insurrance = ''
      this.carInfo.insurranceOther = ''
      this.carInfo.NoticeNo = ''
      this.carInfo.insuranceType = ''
      this.carInfo.startDate = ''
      this.carInfo.endDate = ''
      this.carInfo.consultName = ''
      this.btn_action = 'Submit'
      this.errors = []
      this.registerSuccess = false
      this.sendQRSuccess = false
      this.getToday()
    },
    checkForm (e) {
      if (this.carInfo.branch && this.carInfo.customerName && this.carInfo.customerMobile && this.carInfo.frameNo && this.carInfo.licenseNo && this.carInfo.Model && this.carInfo.Insurrance && this.carInfo.startDate && this.carInfo.endDate && this.carInfo.consultName) {
        return true
      }

      this.errors = []
      if (!this.carInfo.branch) {
        this.errors.push('กรุณาระบุสาขา')
      }
      if (!this.carInfo.customerName) {
        this.errors.push('กรุณากรอกชื่อลูกค้า')
      }
      if (!this.carInfo.customerMobile) {
        this.errors.push('กรุณากรอกเบอร์มือถือลูกค้า')
      }
      if (!this.carInfo.frameNo) {
        this.errors.push('กรุณากรอกเลขตัวถัง')
      }
      if (!this.carInfo.licenseNo) {
        this.errors.push('กรุณากรอกเลขทะเบียน')
      }
      if (!this.carInfo.startDate) {
        this.errors.push('กรุณากรอก วันเริ่มคุ้มครอง')
      }
      if (!this.carInfo.endDate) {
        this.errors.push('กรุณากรอก วันสิ้นสุด')
      }
      if (!this.carInfo.Model) {
        this.errors.push('กรุณาเลือกรุ่นรถ')
      }
      if (!this.carInfo.NoticeNo) {
        this.errors.push('กรุณากรอกเลขที่รับแจ้ง')
      }
      if (!this.carInfo.insuranceType) {
        this.errors.push('กรุณากรอกประเภทประกันภัย')
      }
      if (!this.carInfo.consultName) {
        this.errors.push('กรุณากรอกชื่อ ที่ปรึกษาการขาย')
      }
      e.preventDefault()
    },
    submitCarInfo (e) {
      let _this = this
      if (!this.checkForm(e)) {
        return false
      }
      _this.btn_action = 'Waiting...'
      let params = {
        carInfo: _this.carInfo,
        updatedBy: _this.updatedBy
      }
      console.log(params)
      this.$axios
        .post(`${this.$apiUrl}setInsuranceInfo`, params)
        .then(response => {
          _this.carId = response.data.carId
          _this.urlconfirm += `carId=${_this.carId}`
          _this.registerSuccess = true
          if (process.env.NODE_ENV !== 'development') {
            _this.sendQRCode()
          } else {
            // _this.sendQRSuccess = true
            _this.sendQRCode()
          }
        })
    },
    sendQRCode () {
      let _this = this
      console.log(_this.carInfo)
      const branch = this.$branchList.find((temp) => temp.id === _this.carInfo.branch)
      this.$axios
        .get(`${this.$apiUrl}sendQRCodeToInsurance?branchName=${branch.name}&Insurrance=${_this.carInfo.Insurrance}&startDate=${_this.carInfo.startDate}&endDate=${_this.carInfo.endDate}&customerName=${_this.carInfo.customerName}&customerMobile=${_this.carInfo.customerMobile}&pictureUrl=${_this.profile.pictureUrl}&frameNo=${_this.carInfo.frameNo}&licenseNo=${_this.carInfo.licenseNo}&Model=${_this.carInfo.Model}&carId=${_this.carId}&consultName=${_this.carInfo.consultName}`)
        .then(response => {
          _this.sendQRSuccess = true
        })
    },
    openWindow () {
      this.$liff.openWindow({
        url: 'https://developers.line.me/en/docs/liff/overview/'
      })
    },
    closeWindow () {
      this.$liff.closeWindow()
    },
    sendMessage () {
      let _this = this
      this.$liff.sendMessages([
        {
          type: 'text',
          text: 'You/\'ve successfully sent a message! Hooray!'
        },
        {
          type: 'sticker',
          packageId: '2',
          stickerId: '144'
        }
      ]).then(function () {
        _this.closeWindow()
        console.log('Message sent')
      }).catch(function (error) {
        console.log('Error sending message: ' + error)
      })
    },
    getProfile () {
      let _this = this
      this.$liff.getProfile().then(function (profile) {
        _this.profile = profile
      }).catch(function (error) {
        console.log('Error getting profile: ' + error)
      })
    },
    getProfile_dev () {
      this.profile = {
        'displayName': 'Pamorn Trivorrarat',
        'pictureUrl': 'https://profile.line-scdn.net/0hehdTyqPSOkdZLRSQHV5FEGVoNCouAzwPIUl2JX4pNnQnSHsUMRx8dCgoNCUmTS1BMRhzKHQpMyN9',
        'statusMessage': 'ใช้ไลน์อันนี้นะคร้าบ',
        'userId': 'U691b2080970333bbeb4930dadc6618b6'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RegisterInsurrance.vue